/**
 * Reference-photo Storage helpers (handheld ingest, Segment 2).
 *
 * The client uploads the image to handheld-reference-photos/{jobId}/{subjectId}/
 * {photoId} (the Segment 0 Storage rule enforces auth + role + image + <10MB),
 * then calls the setReferencePhoto callable with the returned PATH. We store the
 * path on the subject, never a tokenized download URL (build plan §4); display
 * resolves the path to a short-lived download URL at view time.
 */
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase.js";

const safe = (s) =>
  String(s ?? "").replace(/[^a-zA-Z0-9._-]+/g, "-").replace(/^-+|-+$/g, "");

export const referencePhotoPath = (jobId, subjectId, photoId) =>
  `handheld-reference-photos/${jobId}/${subjectId}/${photoId}`;

/** Upload an image File for a subject; resolves to its Storage PATH. */
export async function uploadReferencePhoto(jobId, subjectId, file) {
  const photoId = `${Date.now()}_${safe(file.name) || "photo"}`;
  const path = referencePhotoPath(jobId, subjectId, photoId);
  await uploadBytes(storageRef(storage, path), file, { contentType: file.type });
  return path;
}

/** Resolve a stored Storage PATH to a download URL for display. */
export const resolvePhotoUrl = (path) => getDownloadURL(storageRef(storage, path));
